import React from 'react';
import { AccessGateProvider } from './contexts/AccessGateContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Bio } from './components/Bio';
import { Gallery } from './components/Gallery';
import { ExclusiveTease } from './components/ExclusiveTease';
import { Footer } from './components/Footer';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="2rl6vf6ijosua">
      <AccessGateProvider data-id="element-1" data-mp="2riklx1c3g39f">
        <div className="w-full min-h-screen bg-black" data-id="element-2" data-mp="2mmcbu2cr7094">
          <Header data-id="element-3" data-mp="2mjpw3ffpleft" />
          <Hero data-id="element-4" data-mp="31aqfuglwour9" />
          <Bio data-id="element-5" data-mp="31b8jvzet8d9q" />
          <Gallery data-id="element-6" data-mp="31bs27h8dh3oa" />
          <ExclusiveTease data-id="element-7" data-mp="31c9vq63nh3si" />
          <Footer data-id="element-8" data-mp="31cjnnz899l0u" />
        </div>
      </AccessGateProvider>
    </LanguageProvider>;
}